<template>
  <div class="app-container">
    <el-card shadow="hover">
      <!-- 查询和其他操作 -->
      <div class="filter-container" style="float:rigth">
        <!-- <el-button class="filter-item" type="primary" style="margin-bottom: 10px;" icon="el-icon-edit"  @click="handleMessageAsync()">同步会话</el-button> -->
      </div>

      <div style="display: flex;overflow-y: auto;">
        <div class="chat-left">
          <el-input v-model="listQuery.mobile" clearable class="filter-item" style="width: 150px;" placeholder="请输入商家手机" />
          <el-select v-model="listQuery.userId"  style="width:120px" clearable placeholder="请选择运营" filterable>
                        <el-option v-for="(item,index) in users" :key="index" :label="item.userName" :value="item.userId"></el-option>
            </el-select>
          <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
          <el-table v-loading="listLoading" :data="list" element-loading-text="正在查询中。。。" border fit
            highlight-current-row>
            <el-table-column align="left" label="商家列表" prop="name">
              <template slot-scope="scope">
                <div style="display: flex;align-items: center;cursor: pointer;" @click="handleWorkerMsg(scope.row)">
                  <img width="30" class="sc-message--avatar" :src="scope.row.avatar" />
                  {{ scope.row.name }}<br />{{ scope.row.remark }}
                </div>
                <div style="float: right;margin-top: -45px;">
                  共{{ scope.row.msgCount ? scope.row.msgCount : 0 }}条消息
                  <p v-if="scope.row.msgCount">最新消息：{{ scope.row.createTime }}</p>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <pagination v-show="total > 0" :total="total" layout="total,prev,next,jumper" :page.sync="listQuery.pageIndex"
            :limit.sync="listQuery.pageSize" @pagination="getList" />
        </div>

        <div class="chat-right">
          <div class="chat-title">与【{{ workerName }}】的聊天内容</div>
          <div class="more" v-if="msgList.length > 0" style="cursor:pointer" @click="btnMore">--加载更多聊天内容--</div>
          <div class="more" v-else>--没有聊天内容--</div>
          <div class="sc-message" v-for="msg in msgList" :key="msg.id">
            <div :class="msg.msgFt == 'from' ? 'sc-message--content received' : 'sc-message--content to'">
              <div class="sc-message--avatar has-tooltip" data-original-title="Matteo" v-if="msg.msgFt == 'to'">
                <i class="el-icon-s-custom" style="font-size:36px"></i>
              </div> 
              <!-- 发送人，发送日期 -->
              <div :class="msg.msgFt == 'from' ? 'sc-message-from-text' : 'sc-message-to-text'">
                <div style="font-size: 9px;color:#6a5656" :class="msg.msgFt == 'from' ? 'text-right' : 'text-left'"> {{ msg.msgFt == 'to'?msg.toUserName:msg.fromUserName }} {{
                  msg.createTime
                }} </div>

                <!-- 图片、文件等替代格式显示 -->
                <a :href="msg.url" target="_blank" style="display: inline-block;">
                  <i :class="[msgTypes[msg.msgType],msg.msgFt == 'from' ?'icon-right': 'text-left']" 
                    v-if="msg.msgType == 'file' || msg.msgType == 'video' || msg.msgType == 'location'"></i>
                </a> 
                <i :class="[msgTypes[msg.msgType],msg.msgFt == 'from' ?'icon-right': 'text-left']" 
                    v-if="msg.msgType == 'voice'" @click="playAmr(msg.url)"></i>
                <!-- 加载纯文本内容 -->
                <div class="sc-message--text-content" v-if="msg.content">
                  <span style="float:left;margin-top: 2px;" v-if="msg.msgFt == 'to'">{{ msg.content }} </span>
                  <span style="float:right;margin-top: 2px;" v-else>{{ msg.content }} </span>
                </div>
                <img v-if="msg.msgType == 'image'" :src="msg.url" style="width: 320px;" />
              </div>

              <div class="sc-message--avatar has-tooltip" data-original-title="Matteo" v-if="msg.msgFt == 'from'">
                <img width="36" class="sc-message--avatar" :src='msg.avatar' />
              </div>

            </div>

            <!-- <div class="sc-message--content to" v-else>
              <div class="sc-message--avatar has-tooltip" data-original-title="Matteo">
                <i class="el-icon-s-custom" style="font-size:36px"></i>
              </div>
              <div class="sc-message-to-text">
                <div style="font-size: 9px;"> {{ msg.createTime }} </div>
                <div class="sc-message--text-content">
                  <div style="float:left;margin-top: 2px;">{{ msg.content }} </div>
                </div>
              </div>
            </div> -->

          </div>

        </div>
      </div>
    </el-card>
  </div>
</template>

  
<script>
import service from "@/script/api/workercrmapi";
import Pagination from "@/components/common/Pagination";


export default {
  name: "cpTag",
  components: { Pagination },
  filters: {
  },
  data() {
    return {
      msgTypes: {
        file: 'el-icon-folder',
        video: 'el-icon-video-play',
        voice: 'el-icon-chat-line-round',
        location: 'el-icon-location-information'
      },
      list: [],
      total: 0,
      isLastPage: false,
      listLoading: true,
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        userId:'',
        sort: "create_time",
        order: "desc",
      },
      msgQuery: {
        pageIndex: 1,
        externalUserid: ''
      },
      msgList: [],
      workerName: '',
      users:[],
      amr:null,//用来播放amr文件
      isPlay:false//是否在播放中
    };
  },
  created() {
    this.getList();
    this.getUserList();
  },
  methods: {
    handleWorkerMsg(row) {
      if (row.externalUserid == this.msgQuery.externalUserid) return;
      this.msgList = [];
      this.isLastPage = false;
      this.workerName = row.workerName ? row.workerName : row.name;
      this.msgQuery.pageIndex = 1;
      this.msgQuery.externalUserid = row.externalUserid;
      this.getMsgList();
    },
    getMsgList() {
      if (this.isLastPage) {
        this.$notify.success({
          title: "提醒",
          message: "没有更多聊天内容"
        });
        return;
      }
      this.msgQuery.userId=this.listQuery.userId;
      service.$axiosCpGetMsg(this.msgQuery).then(res => {
        this.msgList = res.data.data.list.concat(this.msgList);
        this.isLastPage = res.data.data.isLastPage;
        if (res.data.data.list.length == 0) {
          this.isLastPage = true;
          this.$notify.success({
            title: "提醒",
            message: "没有更多聊天内容"
          });
        }
      })
    },
    playAmr(url){
      if(this.isPlay){
        this.isPlay=false;
        if(this.amr.isPlaying())
         this.arm.stop();
      }
      else {
        var BenzAMRRecorder=require('benz-amr-recorder');
        this.amr=new BenzAMRRecorder();
        this.isPlay=true;
        this.amr.initWithUrl(url).then(()=>{
          this.amr.play();
        });
        this.amr.onEnded(()=>{
          this.isPlay=false;
        })
      } 
    },
    btnMore() {
      this.msgQuery.pageIndex = this.msgQuery.pageIndex + 1;
      this.getMsgList();
    },
    getList() {
      this.listLoading = true;
      service
        .$axiosCpChatWorkerList(this.listQuery)
        .then((response) => {
          this.list = response.data.data.list;
          this.total = response.data.data.total;
          this.isLastPage = response.data.data.isLastPage;
          this.listLoading = false;
        })
        .catch(() => {
          this.list = [];
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleMessageAsync() {
      service.$axiosCpMessageSync().then(res => {
        this.$notify.success({
          title: "成功",
          message: "同步中，请稍后刷新",
        });
      })
    },
    getUserList(){
      service.$axiosCpGetUserList().then(res=>{
        this.users=res.data.data
      })
    }
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.el-button--text {
  padding: 0 !important;
  width: auto !important;
  margin-left: 5px !important;
}

.el-button--text span {
  margin-left: 0px !important;
}

.chat-left {
  width: 20%;
  border: 1px solid #EBEEF5;
}

.chat-right {
  border: 1px solid #EBEEF5;
  width: 78%;
  margin-left: 3px;
}

.chat-title {
  height: 42px;
  background-color: #EBEEF5;
  padding: 10px;
}

.sc-message {
  /* width: 300px; */
  padding-bottom: 10px;
  display: flex;
  margin: 10px 0 0 10px;
}

.sc-message--content {
  width: 100%;
  display: flex;
}

.sc-message--avatar {
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: 50%;
  min-width: 30px;
  min-height: 30px;
  border-radius: 50%;
  align-self: center;
  margin-right: 15px;
}

.sc-message--content.received {
  justify-content: right;
  width: 100%;
}

.sc-message--content.received .sc-message-from-text {
  color: #263238;
  /* background-color: #f4f7f9; */
  margin-right: 20px;
  color: rgb(34, 34, 34);
  background-color: rgb(234, 234, 234);
  padding: 5px 20px;
  border-radius: 6px;
  font-weight: 300;
  font-size: 14px;
  line-height: 1.4;
  position: relative;
  -webkit-font-smoothing: subpixel-antialiased;
}

.sc-message--content.to .sc-message-to-text {
  color: #263238;
  margin-right: 40px;
  /* color: rgb(10 3 38); */
  background-color: #a0c0e1;
  padding: 5px 20px;
  border-radius: 6px;
  font-weight: 300;
  font-size: 14px;
  line-height: 1.4;
  position: relative;
  -webkit-font-smoothing: subpixel-antialiased;
}

.sc-message--text .sc-message--toolbox {
  transition: left .2s ease-out 0s;
  white-space: normal;
  opacity: 0;
  position: absolute;
  left: 0;
  width: 25px;
  top: 0;
}

.float-right {
  float: right;
}

.icon-right{
  font-size:50px;
  float: right;
}

.icon-left{
  font-size:50px;
  float: left;
}


.text-right {
  text-align: right;
  font-size: 9px;
}

.text-left {
  text-align: left;
  font-size: 9px;
}

.more {
  display: flex;
  justify-content: center;
  margin-top: 5px;
  font-size: 12px;
  color: #666698;
}
</style>